
import { ACCESS_TYPES } from 'components/vortex/CreateVortexRoom'
import { logWithTime } from 'util/screenUtils'
import { getCoreServiceFetchOptions } from './CoreServiceController'

/**
 * If response is not ok, read the error response JSON, and then throw that JSON.
 * Otherwise, just return the response.
 * @param {*} response
 * @returns
 */
export const handleErrors = async (response) => {
  if (!response.ok) {
    const thing = await response.json()
    console.log('handleErrors error', thing)
    throw new Error(thing.message ? thing.message : JSON.stringify(thing), { cause: thing })
  }
  return response
}

/**
 * If response is not ok, read the error response JSON, and then throw that JSON
 * with the status code.
 * Otherwise, just return the response.
 * @param {*} response
 * @returns {errorRespose,status}
 */
export const handleErrorsWithCode = async (response) => {
  if (!response.ok) {
    const errorResponse = await response.json()
    console.log(`errorResponse status ${response.status}`, errorResponse)
    throw { errorResponse, status: response.status }
  }
  return response
}

/**
 * 
 * @param {*} ownerUsername 
 * @param {*} isOwner 
 * @returns 
 */
export const fetchRooms = async (ownerUsername, isOwner) => {
  logWithTime(`fetchRooms for ${ownerUsername} isOwner ${isOwner}`)
  const availableRooms = await getUserRooms(
    ownerUsername
  )
  console.log('rooms', availableRooms)
  const allowedRooms = isOwner ? availableRooms : availableRooms.filter(r => r.room.accessType !== ACCESS_TYPES.PRIVATE)
  allowedRooms.sort(function (a, b) {
    const textA = a.originalTitle.toUpperCase()
    const textB = b.originalTitle.toUpperCase()
    return textA < textB ? -1 : textA > textB ? 1 : 0
  })
  return allowedRooms
}

/**
 * Requires Api Key
 * This gets up to 50 user rooms.
 * @param {*} username 
 * @returns 
 */
const getUserRooms = async (username) => {
  const url = `${process.env.REACT_APP_CORE_SERVICE}rooms/${username}/0/50`
  console.log(`getUserRooms from ${url}`)
  return fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': process.env.REACT_APP_API_KEY
    }
  })
    .then(handleErrors)
    .then((res) => res.json())
    .then((rooms) => {
      return rooms
    })
}

/**
 * This will get the Asset and the associated Room.
 *  ApiKey required
 * @param {*} assetParams {assetId} {title,user}
 * @returns 
 */
export const getAsset = async (assetParams) => {
  console.log(`getAsset`, assetParams)
  const url = `${process.env.REACT_APP_CORE_SERVICE}assets/asset`
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': process.env.REACT_APP_API_KEY
    },
    body: JSON.stringify(assetParams)
  })
    .then(handleErrors)
    .then((res) => res.json())
    .then((asset) => {
      return asset
    })
}

/**
 * Update the asset on the server, using the _id field in the passed asset.
 * @param {*} asset
 * @returns Either {metadata,assetId} or {assetId}
 */
export const updateAsset = async (asset) => {
  return fetch(`${process.env.REACT_APP_CORE_SERVICE}assets/update`,
    getCoreServiceFetchOptions('POST', JSON.stringify(asset)))
    .then(handleErrors)
    .then((res) => res.json())
    .then((updated) => {
      return updated
    })
}

